module.exports = __webpack_public_path__ + "static/media/NAININTFontHallA0010_bg_clean_v001.dbf7d9cc.webp";